/* File: language.jsx
 * Path: ananunadm/src/components/main/language.jsx
*/
import { Modal, Card, ActionIcon, Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { T } from "@/helpers/translator";
import { useLang, LanguagePicker } from "@/helpers/language";

const data = [
	{
		label: "English",
		image: <span className="fi fi-us"></span>,
		value: "en"
	},
	{
		label: "Русский",
		image: <span className="fi fi-ru"></span>,
		value: "ru"
	},
	{
		label: "Հայերեն",
		image: <span className="fi fi-am"></span>,
		value: "hy"
	},
	{
		label: "Türkçe",
		image: <span className="fi fi-tr"></span>,
		value: "tr"
	},
	{
		label: "العربية",
		image: <span className="fi fi-sa"></span>,
		value: "ar"
	},
	{
		label: "中文",
		image: <span className="fi fi-cn"></span>,
		value: "zh"
	},
	{
		label: "فارسی",
		image: <span className="fi fi-ir"></span>,
		value: "fa"
	},
	{
		label: "עברית",
		image: <span className="fi fi-il"></span>,
		value: "he"
	},
	{
		label: "Français",
		image: <span className="fi fi-fr"></span>,
		value: "fr"
	},
	{
		label: "Español",
		image: <span className="fi fi-es"></span>,
		value: "es"
	},
	{
		label: "Português",
		image: <span className="fi fi-pt"></span>,
		value: "pt"
	}
];

function Language({ isMobile, compact }) {
	const { lang } = useLang();
	const [opened, OpenClose] = useDisclosure(false);

	return (
		<>
			<Button
				onClick={OpenClose.toggle}
				variant="subtle"
				mx={compact ? (isMobile ? 2 : 4) : isMobile ? 5 : 10}
				aria-label={T("language", lang)}
				title={T("language", lang)}
				size={isMobile ? "sm" : "md"}
				style={{ margin: 0, padding: 10 }}
			>
				{data.find((item) => item.value === lang)?.image}
			</Button>
			<Modal
				opened={opened}
				onClose={OpenClose.close}
				title={T("language", lang)}
				centered
				overlayProps={{
					opacity: 0.55,
					blur: 3
				}}
			>
				<LanguagePicker data={data} />
			</Modal>
		</>
	);
}

export default Language;
